module.exports = __webpack_public_path__ + "static/media/velour4D.9a7b7cf4.jpg";